export default __webpack_public_path__ + "static/media/congrats.93cbc1ce.png";